import React, { useState } from "react";
import { DataContext } from "../../../App";
import Modal from "../Modals/Modal";
import {
	Button,
	MenuItem,
	ListItemIcon,
	ListItemText
} from "@mui/material";
import DeliveryProof from "@mui/icons-material/FactCheck";
import ArrowRight from "@mui/icons-material/ArrowRightSharp";

export default function PODRequest({
	buttonName, buttonType, orderNumber,
	sellerID, podRequestSent
}) {
	const context = React.useContext(DataContext);

	const [state, setState] = useState({
		isModalOpen: false,
		modalBodyTitle: "",
		modalBodyMessage1: "",
		modalBodyMessage1Data: [],
		modalBodyMessage2: "",
		modalBodyInputFields: {},
		modalButtonVariant1: "",
		modalButtonText1: "",
		modalButtonActionType1: "",
		modalButtonAction1: "",
		modalButtonVariant2: "",
		modalButtonText2: "",
		modalButtonActionType2: "",
		modalButtonAction2: "",
		modalButtonColor2: "primary",
	});

	const onClickRequestProofOfDelivery = () => {
		const getProofOfDeliveryStatus = async () => {
			setState(previousState => {
				return {
					...previousState,
					isModalOpen: true,
					modalBodyTitle: "Request Proof of Delivery",
					modalBodyMessage1: state.modalBodyMessage1,
					modalBodyMessage2: state.modalBodyMessage2,
					modalButtonVariant1: "outlined",
					modalButtonText1: "Close",
					modalButtonActionType1: "close",
					modalButtonAction1: "",
				};
			});

			if (podRequestSent === true) {
				setState(previousState => {
					return {
						...previousState,
						modalBodyMessage1: "You have already submitted this request.",
						modalBodyMessage2: "You will receive email confirmation of your request shortly, if you do not receive confirmation please contact support@gonini.com",
					};
				});
				return;
			}

			return context.dataProvider.createProofOfDeliveryRequest(orderNumber, sellerID)
				.then(() => {
					setState(previousState => {
						return {
							...previousState,
							modalBodyMessage1: "Proof of Delivery request, successfully sent.",
							modalBodyMessage2: "You will receive email confirmation of your request shortly. We will also email you the Proof of Delivery once your request has been completed.",
						};
					});
				})
				.catch(error => {
					if (error.response.status === 409) {
						setState(previousState => {
							return {
								...previousState,
								modalBodyMessage1: "You have already submitted this request.",
								modalBodyMessage2: "You will receive email confirmation of your request shortly, if you do not receive confirmation please contact support@gonini.com",
							};
						});
					} else {
						setState(previousState => {
							return {
								...previousState,
								modalBodyMessage1: "Error: Please try again or contact support@gonini.com",
								modalBodyMessage2: "",
							};
						});
					}
				});

		};
		getProofOfDeliveryStatus();
	};

	const onModalClose = () => {
		setState(previousState => {
			return {
				...previousState,
				isModalOpen: false,
			};
		});
	};

	return (
		<>
			{buttonType === "button" ?
				<Button
					variant="outlined"
					color="secondary"
					onClick={onClickRequestProofOfDelivery}
				>
					{buttonName}
				</Button>
				:
				<MenuItem
					data-testid="menu-button"
					onClick={onClickRequestProofOfDelivery}
				>
					<ListItemIcon>
						<DeliveryProof />
					</ListItemIcon>
					<ListItemText>
						{buttonName}
					</ListItemText>
					<ArrowRight />
				</MenuItem>
			}

			<Modal
				onModalClose={onModalClose}
				isModalOpen={state.isModalOpen}
				modalSize={state.modalSize}
				modalBodyTitle={state.modalBodyTitle}
				modalBodyMessage1={state.modalBodyMessage1}
				modalBodyMessage1Data={state.modalBodyMessage1Data}
				modalBodyMessage2={state.modalBodyMessage2}
				modalBodyInputFields={state.modalBodyInputFields}
				modalButtonVariant1={state.modalButtonVariant1}
				modalButtonText1={state.modalButtonText1}
				modalButtonActionType1={state.modalButtonActionType1}
				modalButtonAction1={state.modalButtonAction1}
				modalButtonVariant2={state.modalButtonVariant2}
				modalButtonText2={state.modalButtonText2}
				modalButtonActionType2={state.modalButtonActionType2}
				modalButtonAction2={state.modalButtonAction2}
				modalButtonColor2={state.modalButtonColor2}
			/>
		</>
	);

}
